import { useEffect, useState } from 'react';
import type { LanEventRow } from '@kassa/shared';
import { api } from '../../api';

const KIND: Record<LanEventRow['kind'], string> = { connect: 'qoşuldu', disconnect: 'ayrıldı', rejected: 'rədd edildi' };
const LINK: Record<LanEventRow['link'], string> = { lan: 'kabel', wifi: 'Wi-Fi', unknown: '' };

// Son LAN bağlantıları (KT-83): kassa ↔ ana kompüter qoşulma/ayrılma jurnalı (cihazlarda yazılır, internet gələndə auditə gedir).
export function LanEvents() {
  const [rows, setRows] = useState<LanEventRow[] | null>(null);
  useEffect(() => {
    api.deviceLanEvents().then(setRows).catch(() => setRows([]));
  }, []);
  if (!rows || rows.length === 0) return null;
  return (
    <div className="device-connect" aria-label="Son LAN bağlantıları">
      <h3>Son LAN bağlantıları</h3>
      <ul className="module-list">
        {rows.map((r) => (
          <li key={r.id}>
            <span>
              {r.deviceName} ← {r.peerName ?? 'naməlum cihaz'} · {KIND[r.kind]}
              {r.reason ? ` (${r.reason})` : ''}
            </span>
            <span className="muted small">
              {new Date(r.at).toLocaleString('az-AZ', { timeZone: 'Asia/Baku' })} {r.ip ?? ''} {LINK[r.link]}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
